import {RootState} from '../Redux/store';
import {Tabs} from '../lib/components/tabbar';
import {IMessage} from '../Constants/Interfaces';
import {isUserId} from '../Users';
import {auth, db} from '../Firebase/main';


export interface INotifications {
    [Tabs.home]: number;
    [Tabs.buddies]: number;

    [uid: string]: number;
}


export async function sendPublicMessage(data: { message: string, sender: string, sender_name: string, receiver: string }): Promise<any> {
    const timestamp = new Date().getTime();
    const {receiver, ...rest} = data;
    const payload = {...rest, timestamp, unread: false};
    return db
        .ref(`public_messages/${receiver}/${timestamp}`)
        .set(payload)

        .then(console.log)
        .catch((err) => console.error('Failed public message send', err));
}


export async function sendPrivateMessage(data: { message: string, sender: string, sender_name: string, receiver: string }): Promise<any> {
    const timestamp = new Date().getTime();

    const {receiver, sender, ...rest} = data;

    const payload: Partial<IMessage> = {sender, timestamp, ...rest};

    return db
        .ref(`private_messages/${receiver}/${sender}/${timestamp}`)
        .set({...payload, unread: true} as IMessage)
        .then(() => db
            .ref(`private_messages/${sender}/${receiver}/${timestamp}`)
            .set({...payload, unread: false})
            .catch((error) => console.error('Failed message save', error.message)))
        .catch((error) => console.error('Failed message send', error.message));

}


export async function readMessage(message: IMessage): Promise<any> {
    const {sender, timestamp} = message;

    const myId = auth.currentUser?.uid;
    if (!myId) {
        throw new Error('Authentication missing');
    }

    return db
        .ref(`private_messages/${myId}/${sender}/${timestamp}`)
        .update({unread: false})
        .catch(console.error);
}


export function parseNotifications(state: RootState): INotifications {
    const notificationsResult: INotifications = {[Tabs.home]: 0, [Tabs.buddies]: 0};

    const {messages: {private_messages}} = state;
    Object
        .entries(private_messages)
        .forEach(([uid, messages]) => {

            if (!messages) return;

            const unreadMessagesCount = Object.values(messages).filter((msg) => msg.unread).length;
            if (unreadMessagesCount) {
                notificationsResult[uid] = unreadMessagesCount;
            }
        });

    return notificationsResult;
}


export function getCurrentChatMessages(state: RootState): IMessage[] {
    let result: IMessage[] = [];

    const {messages: {private_messages, public_messages}, main: {selectedId}} = state;

    if (!selectedId || !private_messages[selectedId] && !public_messages[selectedId]) return result;

    result = Object.values(isUserId(selectedId) ? private_messages[selectedId] : public_messages[selectedId]);

    return result;
}
